import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { translateCollectionType } from "../utils/collectionTypeUtils";
import { formatCollectionMedium, formatCollectionName, formatCollectionStatus, } from "../utils/collectionDisplayUtils";
export var useCollectionsTable = function (onRowClick) {
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var tableColumns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.collections.table.columns.type",
            }),
            key: "type",
            cellRenderer: function (item) {
                return translateCollectionType(item.type || "", formatMessage);
            },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.collections.general.publisher.selection.label",
            }),
            key: "publisher",
            cellRenderer: function (item) { var _a; return ((_a = item.publisher) === null || _a === void 0 ? void 0 : _a.name) || ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.collections.table.columns.issn",
            }),
            key: "issn",
        },
        {
            name: formatMessage({
                id: "ui-br-agency.collections.table.columns.mainName",
            }),
            key: "mainName",
            cellRenderer: function (item) { return formatCollectionName(item); },
            clickable: true,
            onClick: onRowClick ||
                (function (item) {
                    history.push("/bragency/collections/".concat(item.id));
                }),
        },
        {
            name: formatMessage({
                id: "ui-br-agency.collections.table.columns.status",
            }),
            key: "status",
            cellRenderer: function (item) {
                return formatCollectionStatus(item, formatMessage);
            },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.collections.table.columns.medium",
            }),
            key: "medium",
            cellRenderer: function (item) {
                return formatCollectionMedium(item.medium, formatMessage);
            },
        },
    ]; }, [formatMessage, history, onRowClick]);
    return {
        tableColumns: tableColumns,
    };
};
